import { render, staticRenderFns } from "./hediyezh.vue?vue&type=template&id=1b87a9ac&scoped=true"
import script from "./hediyezh.vue?vue&type=script&lang=js"
export * from "./hediyezh.vue?vue&type=script&lang=js"
import style0 from "./hediyezh.vue?vue&type=style&index=0&id=1b87a9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87a9ac",
  null
  
)

export default component.exports